import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { FaArrowDown } from 'react-icons/fa';
import { FaArrowUp } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export const CustomSelectComponent = ({ handleSelection, options, resetValue = false, selectedOptionDefault, isDisabled = false, dataTestId='customSelect' }) => {
  const { t } = useTranslation(['backoffice']);
  const [inputValue, setInputValue] = useState('');
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSelectOpen, setIsSelectOpen] = useState(false);

  useEffect(() => {
    resetValue && setSelectedOption(null);
  }, [resetValue]);

  useEffect(() => {
    selectedOptionDefault && setSelectedOption(selectedOptionDefault);
  }, [selectedOptionDefault]);

  useEffect(() => {
    if(isDisabled) setIsSelectOpen(false)
  }, [isDisabled]);

  const handleInputChange = (newValue) => {
    setInputValue(newValue);
  };

  const handleSelectChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    if (selectedOption) {
      handleSelection(selectedOption);
    }
  };

  const filterOptions = (options, inputValue) => {
    return options.filter(
      (option) =>
        option.label.toLowerCase().includes(inputValue.toLowerCase()) ||
        option.subtitle.toLowerCase().includes(inputValue.toLowerCase()),
    );
  };

  const formatOptionLabel = ({ label, subtitle }) => (
    <div>
      <div className="option-label">{label}</div>
      <div className="optiont-subtitle ">{subtitle}</div>
    </div>
  );

  const handleSelectOpen = () => {
    if (!isDisabled) setIsSelectOpen(!isSelectOpen)
  };

  return (
    <div className="custom-select-wrapper">
      <div className={`custom-select-container ${isSelectOpen ? 'open' : ''} ${isDisabled && 'disabled'}`} data-testid={dataTestId}>
        <div
          className={`selected-option ${isSelectOpen ? 'select-label' : ''}`}
          onClick={handleSelectOpen}
        >
          <div className={`selected-option-content ${isSelectOpen ? 'expanded' : ''}`}>
            <p className="option-label">
              {selectedOption ? selectedOption.label : t('promoCodes.placeholderLibraries')}
            </p>
            {selectedOption && <p className="optiont-subtitle">{selectedOption.subtitle}</p>}
          </div>
          {isSelectOpen ? <FaArrowUp className="arrow-icon" /> : <FaArrowDown className="arrow-icon" />}
        </div>
        {isSelectOpen && (
          <div className="select-dropdown-wrapper">
            <Select
              placeholder={t('search')}
              className="basic-single select-dropdown"
              classNamePrefix="select"
              value={selectedOption}
              isClearable
              isSearchable
              onInputChange={handleInputChange}
              onChange={(selectedOption) => {
                setIsSelectOpen(false);
                handleSelectChange(selectedOption);
              }}
              options={filterOptions(options, inputValue)}
              formatOptionLabel={formatOptionLabel}
              menuIsOpen
              isDisabled={isDisabled}
            />
          </div>
        )}
      </div>
    </div>
  );
};
